import React from "react";
import { Layout, Row, Col, Input, Form, Button, Select, Modal } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { Header, AutoCompleteCompany } from "components";
import { useNavigate, useParams } from "react-router-dom";
import { getByIdUser, saveNewCompanyUser } from "services/user-service";
import { getCorporateCardEmployees } from "services/card-service";
import { bindActionCreators } from "redux";
import * as authAction from 'actions/auth-action';
import { connect } from "react-redux";
import { themeColors } from "theme";

const { Footer, Content } = Layout;

const DataFetch = {
    user: {},
    userKeys: [],
    newAccount: null,
    loading: false
}


const mapStateToProps = (state) => ({ login: state.authReducer.loginReducer, });
const mapDispatchToProps = (dispatch) => bindActionCreators({ ...authAction, }, dispatch);

const UserChangeCompanyScreen = (props) => {
    const { id = null } = useParams();
    const [data, setData] = React.useState(DataFetch)
    const [recipientCompany, setRecipientCompany] = React.useState(null);
    const [hasCorporateCard, setHasCorporateCard] = React.useState(false);
    const [form] = Form.useForm();
    const { login } = props;
    const navigate = useNavigate();

    const load = async () => {
        setData((x) => ({ ...x, loading: true }));
        const res = await getByIdUser(id)
        setData({
            user: res.data,
            userKeys: [{
                account_holder_id: res.data.externalKey,
                balance_account_group_id: res.data.account,
                treasury_account_holder_id_actual: res.data.companyExternal.externalKey,
                treasury_account_holder_id_new: '',
                treasury_account_id_new: ''
            }],
            loading: false
        });
        form.setFieldsValue({
            "senderCompany": res.data.company.name,
        });

        const employees = await getCorporateCardEmployees();
        setHasCorporateCard(employees.some(e => String(e.id) === String(id)));
    }

    const doSave = async () => {
        setData((x) => ({ ...x, loading: true }));
        try {
            await form.validateFields()
            await saveNewCompanyUser(id, recipientCompany);
            navigate("/user");
        } finally {
            setData((x) => ({ ...x, loading: false }));
        }
    }

    const onSave = async () => {
        if (data.user.hasPendingIncomes !== undefined && data.user.hasPendingIncomes) {
            Modal.warning({
                title: "Existem cargas pendentes para esse participante!",
                content: "Para alterá-lo de empresa, é necessário que as cargas pendentes sejam canceladas.",
            });
            return;
        }

        if (hasCorporateCard) {
            Modal.confirm({
                title: "Participante possui cartão corporativo ativo",
                content: "Ao confirmar a migração, o cartão corporativo será bloqueado e o saldo disponível será devolvido automaticamente para a empresa de origem. Deseja continuar?",
                okText: "Confirmar migração",
                cancelText: "Cancelar",
                onOk: doSave,
            });
            return;
        }

        await doSave();
    }

    React.useEffect(() => {
        load();
    }, [id])

    return <Layout className="alymente-layout">
        <Header title={"Alteração de Empresa"} subtitle={data.user.name} />
        <Content>
            <Form form={form} layout="vertical" name="basic">
                <Row>
                    <Col span={18} offset={3}>
                        <Row gutter={16}>
                            <Col md={10}>
                                <Form.Item
                                    label="Empresa Atual"
                                    hasFeedback
                                    name="senderCompany"

                                >
                                    <Input autoComplete="off" disabled={true}></Input>
                                </Form.Item>
                            </Col>
                            <Col md={10}>
                                <Form.Item
                                    label={login.company.master ? "Nova Empresa" : "Nova Filial"}
                                    hasFeedback
                                    name="recipientCompany"
                                >
                                    {
                                        login.company.master ?
                                            <AutoCompleteCompany
                                                disabled={data.loading}
                                                loading={data.loading}
                                                onChange={setRecipientCompany}
                                            />
                                            :
                                            login.children && login.children.has &&
                                            <Select
                                                className='alymente-select'
                                                disabled={data.loading}
                                                loading={data.loading}
                                                placeholder="Selecione uma empresa"
                                                title="Trocar de Filial"
                                                value={recipientCompany}
                                                onChange={setRecipientCompany}
                                            >
                                                {login.children.data.map(company => <Select.Option
                                                    style={{
                                                        color: themeColors.darkColor,
                                                    }}
                                                    value={company.id}>
                                                    {company.name}
                                                </Select.Option>)}
                                            </Select>
                                    }
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Form>
        </Content>
        <Footer style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
        }}>
            <Button
                className="btn-save"
                type="primary"
                onClick={() => navigate(`/user/${id}`)}>
                Voltar
            </Button>
            <Button
                disabled={data.loading || !recipientCompany}
                loading={data.loading}
                className="btn-save"
                type="primary"
                icon={<SaveOutlined />}
                width={300}
                onClick={() => onSave()}>
                Migrar de Empresa
            </Button>
        </Footer>
    </Layout>
}

export default connect(mapStateToProps, mapDispatchToProps)(UserChangeCompanyScreen);
